import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import practitionerProfileService from "./practitionerProfileService";

const initialState = {
    profile: {},
    practitionerProfiles: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: "",
};

// Create new practitioner profile
export const createPractitionerProfile = createAsyncThunk(
    "practitionerProfiles/create",
    async (practitionerProfileData, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.user.token
            return await practitionerProfileService.createPractitionerProfile(
                practitionerProfileData, token
            );
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Get practitioner profiles
export const getPractitionerProfiles = createAsyncThunk(
    'practitionerProfiles/getAll',
    async (_,
        thunkAPI) => {
        try {
            return await practitionerProfileService.getPractitionerProfiles()
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    })
// Get user practitioner profile

export const getUserProfile = createAsyncThunk('practitionerProfiles/getUserProfile', async (id,
    thunkAPI) => {
    try {
        const token = thunkAPI.getState().auth.user.token
        return await practitionerProfileService.getUserProfile(id, token)
    } catch (error) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

// Update a practitioner profile
export const updatePractitionerProfile = createAsyncThunk(
    "practitionerProfiles/update",
    async (id, data, thunkAPI) => {
        try {
            // Token not grabbing correctly from getState so had to scrap this for now
            // Need to take a look to fix this eventually
            // const token = thunkAPI.getState().auth.user.token
            const token = localStorage.getItem('token')
            // console.log("token data: ", token)
            // console.log("Slice data: ", data)
            return await practitionerProfileService.updatePractitionerProfile(
                id, data, token
            );
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updatePractitionerImage = createAsyncThunk(
    "practitionerProfiles/image",
    async (id, image, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.user.token
            return await practitionerProfileService.updatePractitionerImage(
                id, token, image
            );
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const practitionerProfileSlice = createSlice({
    name: "practitionerProfile",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(createPractitionerProfile.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createPractitionerProfile.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.profile = action.payload
            })
            .addCase(createPractitionerProfile.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getPractitionerProfiles.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getPractitionerProfiles.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.practitionerProfiles = action.payload
            })
            .addCase(getPractitionerProfiles.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getUserProfile.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getUserProfile.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.profile = action.payload
            })
            .addCase(getUserProfile.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            .addCase(updatePractitionerProfile.pending, (state) => {
                state.isLoading = true
            })
            .addCase(updatePractitionerProfile.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.profile = action.payload
            })
            .addCase(updatePractitionerProfile.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            .addCase(updatePractitionerImage.pending, (state) => {
                state.isLoading = true
            })
            .addCase(updatePractitionerImage.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.profile = action.payload
            })
            .addCase(updatePractitionerImage.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
});

export const { reset } = practitionerProfileSlice.actions;
export default practitionerProfileSlice.reducer;
